// @flow
import React, { Node } from 'react';
import classnames from 'classnames';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { Spinner } from 'Components/frameworks/spinner/Spinner.jsx';
import { themes } from './InputButton.themes';

export type InputButtonProps = {
  children?: Node,
  className?: string,
  color?: Colors,
  dataTestId?: string,
  iconName?: IconName,
  isActive?: boolean,
  isDisabled?: boolean,
  isFilled?: boolean,
  isLoading?: boolean,
  onClear?: (SyntheticEvent<>) => void,
  onClick?: (SyntheticEvent<>) => void,
  theme?: string,
};

export function InputButton(props: InputButtonProps) {
  const {
    children,
    className,
    color,
    dataTestId,
    iconName,
    isActive,
    isDisabled,
    isFilled,
    isLoading,
    onClear,
    onClick,
    theme = 'default',
  } = props;
  const {
    thButton,
    thClear,
    thClearSize,
    thHeightStyle,
    thIcon,
    thIconSelect,
    thLoader,
    thRoot,
    thSpinnerColor,
  } = themes[theme]({
    color,
    isActive,
    isDisabled,
    isFilled,
    isLoading,
  });

  if (!iconName && !children) return null;

  const hasClear = onClear && !isDisabled && isFilled;
  return (
    <div className={classnames(className, thRoot)}>
      <button
        className={thButton}
        data-testid={dataTestId}
        disabled={isDisabled}
        onClick={onClick}
        style={thHeightStyle}
        type="button"
      >
        {!!iconName && <Icon className={thIcon} name={iconName} width="1em" />}
        {isLoading ? (
          <div className={thLoader}>
            <Spinner color={thSpinnerColor} size="small" />
          </div>
        ) : (
          children
        )}
        {!hasClear &&
          !!children && <Icon className={thIconSelect} name={ICONS.SELECT} width=".625rem" />}
      </button>
      {hasClear && (
        <button
          data-testid="InputButtonClear"
          className={thClear}
          disabled={isDisabled}
          onClick={onClear}
          type="button"
        >
          <Icon name={ICONS.CROSS} width={thClearSize} />
        </button>
      )}
    </div>
  );
}
